import { devtools } from 'config/devtools'
import { create } from 'zustand'

import { UseIsNoDataChart } from './types'

export const useIsNoDataChart = create<UseIsNoDataChart>()(
  devtools(
    () => ({
      chartA: {},
      chartB: {},
    }),
    {
      store: 'isNoDataChart',
    },
  ),
)
